import React, { useRef, useState, useEffect } from 'react';
import { HeroSection } from './components/login/HeroSection';
import { VisionBlock } from './components/login/VisionBlock';
import { BusinessesBlock } from './components/login/BusinessesBlock';
import { CommunityBlock } from './components/login/CommunityBlock';
import { InterestSharingBlock } from './components/login/InterestSharingBlock';
import { ComingSoonBlock } from './components/login/ComingSoonBlock';
import { TopStoresShowcase } from './components/login/TopStoresShowcase';
import { FinalCTA } from './components/login/FinalCTA';
import { LoginForm } from './components/login/LoginForm';
import { ChevronDown } from 'lucide-react';

export const LoginPrompt = ({ onGoogleLogin, onTelegramLogin, onGuestContinue }) => {
  const loginFormRef = useRef(null);
  const [showSkipButton, setShowSkipButton] = useState(true);

  const scrollToLogin = () => {
    loginFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // Hide skip button when near login form
  useEffect(() => {
    const handleScroll = () => {
      if (loginFormRef.current) {
        const rect = loginFormRef.current.getBoundingClientRect();
        const isNearLogin = rect.top < window.innerHeight;
        setShowSkipButton(!isNearLogin);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="w-full bg-white font-[Rubik,Inter,sans-serif]" dir="rtl">
      {/* Floating Skip to Login Button */}
      {showSkipButton && (
        <button
          type="button"
          onClick={scrollToLogin}
          className="fixed bottom-8 left-8 z-floating inline-flex items-center gap-2 px-6 py-3 rounded-pill bg-brand-500 text-ink-inverse font-semibold shadow-elevated hover:bg-brand-600 hover:shadow-xl hover:-translate-y-0.5 transition-[background-color,transform,box-shadow] duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2"
          style={{ animation: 'bounce-subtle 2s ease-in-out infinite' }}
        >
          <span>דלג להתחברות</span>
          <ChevronDown className="w-5 h-5" />
        </button>
      )}

      {/* Hero Section - Compact */}
      <HeroSection />

      {/* Vision Block - Compact */}
      <VisionBlock />

      {/* Businesses Block - Compact */}
      <BusinessesBlock />

      {/* Community Block - Compact */}
      <CommunityBlock />

      {/* Interest Sharing Block - Compact */}
      <InterestSharingBlock />

      {/* Coming Soon Block - Compact */}
      <ComingSoonBlock />

      {/* Top Stores Showcase - community-built stores carousel */}
      <TopStoresShowcase />

      {/* Final CTA - Compact */}
      <FinalCTA onContinue={scrollToLogin} />

      {/* Login Form */}
      <div ref={loginFormRef}>
        <LoginForm
          onGoogleLogin={onGoogleLogin}
          onTelegramLogin={onTelegramLogin}
          onGuestContinue={onGuestContinue}
        />
      </div>

      {/* Global styles for smooth scrolling */}
      <style>{`
        html {
          scroll-behavior: smooth;
        }

        @keyframes bounce-subtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        /* Enable hardware acceleration for better performance */
        section, .motion-div {
          will-change: transform, opacity;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
        }
      `}</style>
    </div>
  );
};